
import { map, takeUntil } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Settings } from '../_models/settings/settings.model';
import * as Sentry from '@sentry/angular';
import { AlertService } from './alert.service';
import { GlobalConstants, StorageKeys } from '../_constants';
import { StorageServiceProvider } from './storage.service';
import { CryptoService } from './crypto.service';
import utils from '../utils';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root' 
})
export class RequestHelperProvider {
    //  databaseservice: any;
    private defaultUIDefIDKey: string = `45366299-9083-497b-8343-a8f701521358`;
    private defaultCustomerKey: string = `C93F949C-41B8-4C9E-95AA-B030B31F6F3F`;
    private deviceName: string = GlobalConstants.DeviceName;
    private headers = null;
    private defaultRemoteServer: string = GlobalConstants.DefaultRemoteServer;//`10.80.103.129`;
    public stagingRemoteURL = "actionlist";
    private cancelRequests$ = new Subject<boolean>();
    constructor(public http: HttpClient,
        private alertService: AlertService,
        private storage: StorageServiceProvider,
        private crypto: CryptoService) {
        this.cancelRequests$.subscribe({
            next: () => {
                if (!environment.production) {
                    console.log('Cancel signal received');
                }
            },
            error: (err) => {
                if (!environment.production) {
                    console.error('Error in cancelRequests$', err);
                }
            },
            complete: () => {
                if (!environment.production) {
                    console.log('Cancel stream completed');
                }
            },
        });

        if (!environment.production) {
            console.log('Subscribed to cancelRequests$.');
        }
    }

    async Get(remoteUrl: string, customerKey: string, SessionID: string, SelectedEntities: any, callback: any, errorCallback: any, TenantID?: any, Options?: any, isAuthCall = false) {

        let headers = new HttpHeaders();
        let apiUrl = "";

        if (remoteUrl.indexOf('http://') === 0 || remoteUrl.indexOf('https://') === 0) {

        } else {
            apiUrl = 'https://' + remoteUrl;
        }

        headers = customerKey ? headers.set("CustomerID", customerKey) : headers;
        headers = SessionID ? headers.set("SessionID", SessionID) : headers;
        headers = TenantID ? headers.set("TenantID", TenantID) : headers;
        headers = SelectedEntities ? headers.set("SelectedEntities", SelectedEntities) : headers;
        headers = Options ? headers.set("Options", Options) : headers;
        headers = headers.set("Authorization", "Basic YWRtaW46cGFzc3dvcmQx");

        if (apiUrl.indexOf("configfarm") == -1)
            apiUrl = apiUrl.replace(/(api\/)([^/]+)/, (match, p1, p2) => `${p1}${p2}V2`);

        let auth0: any;

        let SalesReviewRemoteServer = utils.GetSalesReviewRemoteServer();
        let GetStagingRemoteServer = utils.GetStagingRemoteServer();
        const isAgrisLicenseCall = apiUrl.toLowerCase().includes('/agrislicense/');
        if ((apiUrl.includes(SalesReviewRemoteServer) || apiUrl.includes(GetStagingRemoteServer)) && !isAuthCall && !isAgrisLicenseCall) {

            try {
                auth0 = await this.GetAuthTokenFormLocal(apiUrl, SessionID);
            } catch (tokenError) {
                if (errorCallback) {
                    errorCallback(tokenError);
                }
                return;
            }

            // Set the Authorization header if the token is available
            if (auth0) {
                headers = headers.set("Authorization", 'Bearer ' + this.crypto.dencryptString(auth0));
            }
        }

        this.http.get(apiUrl, {
            headers: headers,
        }).pipe(map(data => data),
            takeUntil(this.cancelRequests$) // Automatically cancel when signal is emitted
        ).subscribe(data => {
            if (callback) {
                callback(data);
            }
        },
            async (error: any) => {
                if (error && error.status) {
                    if (error.status == 401) {
                        let settings = this.storage.get(StorageKeys.Settings) || new Settings();
                        if (settings.remoteServer == undefined)
                            settings.remoteServer = this.defaultRemoteServer;


                        let agentFreshSessionId: string = await this.GetAgentSessionId(settings.remoteServer, settings.agentUsername, settings.agentEncryptedPassword, this.defaultCustomerKey, this.defaultUIDefIDKey);
                        if (agentFreshSessionId) {
                            if (agentFreshSessionId && agentFreshSessionId != SessionID) {
                                return this.Get(remoteUrl, customerKey, agentFreshSessionId, SelectedEntities, callback, errorCallback, TenantID, Options);
                            }
                        }
                    }

                    if (errorCallback) {
                        errorCallback(error);
                    }
                }
            }
        );
    }

    async Post(callback: any, remoteUrl: any, _body: any, customerKey: any, SessionID: string, uiDefId: string, ErrorCallback: any, isHttp: boolean = false, islogOff: boolean = false, isQuniqueUrl = false, isAuthCall = false) {
        let headers = new HttpHeaders();
        var initialBody = {
            CustomerID: customerKey,
            SessionID: SessionID,
            UIDefID: uiDefId
        };
        var body = SessionID || customerKey || uiDefId ? initialBody : {};
        Object.keys(_body).forEach((key) => { body[key] = _body[key]; });
        if (islogOff === true) {
            headers = headers.set("SessionID", SessionID);
            body = null;
        }
        //isHttp = true;

        let protocol = "";
        let url = "";
        if (remoteUrl.indexOf('http://') === 0 || remoteUrl.indexOf('https://') === 0) {

        } else {
            protocol = isHttp || remoteUrl.indexOf('localhost') === 0 ? 'http://' : 'https://';
        }

        //  let protocol = isHttp || remoteUrl.indexOf('localhost') == 0 ? 'http://' : 'https://';

        if (remoteUrl.indexOf("WarehouseDeliveryLocation/InsertUpdateDeliveryLocation") !== -1) {
            body = _body;
        }
        url = protocol + remoteUrl;

        if (isQuniqueUrl) {
            url = this.addUniqueQueryParam(url);
        }

        let SalesReviewRemoteServer = utils.GetSalesReviewRemoteServer();
        let GetStagingRemoteServer = utils.GetStagingRemoteServer();
        const isAgrisLicenseCall = url.toLowerCase().includes('/agrislicense/');
        if ((url.includes(SalesReviewRemoteServer) || url.includes(GetStagingRemoteServer)) && !isAuthCall && !isAgrisLicenseCall) {
            if (url.indexOf("configfarm") == -1)
                url = url.replace(/(api\/)([^/]+)/, (match, p1, p2) => `${p1}${p2}V2`);

            let auth0: any;

            try {
                auth0 = await this.GetAuthTokenFormLocal(url, SessionID);
            } catch (tokenError) {
                if (ErrorCallback) {
                    ErrorCallback(tokenError);
                }
                return;
            }

            // Set the Authorization header if the token is available
            if (auth0) {
                headers = headers.set("Authorization", 'Bearer ' + this.crypto.dencryptString(auth0));
            }
        }

        this.http.post(url, body, { headers: headers })
            .pipe(map(data => data), takeUntil(this.cancelRequests$) // Automatically cancel when signal is emitted
            ).subscribe(data => {
                if (callback) {
                    callback(data);
                }
            }, response => {
                if (ErrorCallback) {
                    ErrorCallback(response);
                }
            });

    }
    PostServerCommand(remoteUrl, body, callback, errorCallback, isAgentSession = true) {
        var settings = this.storage.get(StorageKeys.Settings);
        if (settings) {
            this.PostCommand(settings, remoteUrl, body, callback, errorCallback, isAgentSession);
        }
    }
    PostCommand(settings: Settings, remoteUrl, body, callback, errorCallback, isAgentSession) {
        let headers = new HttpHeaders();
        headers = settings.customerKey ? headers.set("CustomerID", settings.customerKey) : headers;
        if (isAgentSession) {
            headers = settings.agentSessionId ? headers.set("SessionID", settings.agentSessionId) : headers;
        } else {
            headers = settings.gatewaySessionId ? headers.set("SessionID", settings.gatewaySessionId) : headers;
        }
        headers = headers.set("Content-Type", "application/json");

        if (body) body.CustomerID = settings.customerKey;

        if (settings.remoteServer == undefined) {
            settings.remoteServer = this.defaultRemoteServer;
        }

        this.http.post('https://' + settings.remoteServer + remoteUrl, body, { headers: headers }).pipe(map(data => data)).subscribe(data => {
            callback(data)
        }, async (response: any) => {
            if (response.status == 401) {
                let settings = this.storage.get(StorageKeys.Settings) || new Settings();
                if (settings.remoteServer == undefined) {
                    settings.remoteServer = this.defaultRemoteServer;
                }
                let agentFreshSessionId: any = await this.GetAgentSessionId(settings.remoteServer, settings.agentUsername, settings.agentEncryptedPassword, this.defaultCustomerKey, this.defaultUIDefIDKey);
                if (agentFreshSessionId && agentFreshSessionId != settings.agentSessionId) {
                    return this.PostCommand(settings, remoteUrl, body, callback, errorCallback, isAgentSession);
                }
            }

            if (errorCallback)
                errorCallback(response);
        });
    }
    postServerCommandInDev(remoteUrl, body, callback, errorCallback) {
        let headers = new HttpHeaders();
        headers = headers.set("CustomerID", "C93F949C-41B8-4C9E-95AA-B030B31F6F3F");
        headers = headers.set("SessionID", "{ddc6dc0d-1a3a-4aad-b823-a93b009e19f2}");
        headers = headers.set("Content-Type", "application/json");
        console.log(JSON.stringify(body));
        this.http.post(remoteUrl, body, { headers: headers }).pipe(map(data => data)).subscribe(data => {
            callback(data)
        }, error => {
            errorCallback(error)
        });
    }
    refreshAgrisLicenseCounter(): Promise<any> {
        return new Promise((resolve, reject) => {

            let refreshLicense = localStorage.getItem('RefreshAgrisLicense');

            if (refreshLicense === 'true') {
                resolve(true);
                return;
            }

            localStorage.setItem("RefreshAgrisLicense", "true");

            this.refreshAgrisLicense((res) => {

                localStorage.setItem("RefreshAgrisLicense", "false");
                if (res === true)
                    resolve(true);
                else
                    reject('License count exceeded. To continue using the app, contact your administrator to ensure there are enough licenses available before retrying.');
            });
        });


    }
    private refreshAgrisLicense(callback) {
        let tenantId = this.storage.get(StorageKeys.DataSet).TenantID;
        let localStorageAgrislicense = localStorage.getItem('agrisLicense');
        if (!localStorageAgrislicense) {
            callback(true);
            return;
        }
        let agrisLicense = localStorage.getItem('agrisLicense') ? JSON.parse(localStorage.getItem('agrisLicense')) : {};
        this.refreshAgris(tenantId, agrisLicense.username, agrisLicense.password, agrisLicense.agrisLicense).then((data: any) => {
            if (data.Message == "True") {
                let license = {
                    username: agrisLicense.username,
                    password: agrisLicense.password,
                    beforeEncrptPassword: agrisLicense.beforeEncrptPassword,
                    agrisLicense: data.ResultString
                }
                localStorage.setItem('agrisLicense', JSON.stringify(license));
                callback(true)
            }
            else {
                this.alertAndLogError(data);
            }
        }, (error) => {
            this.alertAndLogError(error);
            callback(error)
        });
    }
    async refreshAgris(tenantId, username, password, agrisLicense): Promise<any> {

        return new Promise(async (resolve, reject) => {
            var settings = this.storage.get(StorageKeys.Settings);
            let SessionID = settings ? settings.agentSessionId : null;
            let customerKey = settings ? settings.customerKey : null;
            let body = {
                "TenantID": tenantId,
                "UserID": username,
                "Password":encodeURIComponent(password),
                "ExtendedOption": "nko",
                "ExtendedOptionValue": "NAM12",
                "SessionID": SessionID,
                "AgrisSession": agrisLicense
            }
            let remoteUrl = utils.GetSalesReviewRemoteServer();

            await this.Post((data: any) => {
                    if (data) {
                        resolve(data);
                    }
                    else
                        reject('No Data Found!')
                }
                , `${remoteUrl}/AgrisLicense/RefreshLicense`
                , body
                , customerKey
                , SessionID
                , null
                , (error: any) => {
                    reject(error);
                },
                false,
                false,
            );
        });
    }
    // private releaseAgrisLicense(callback, failedcallback) {
    //     let tenantId = this.storage.get(StorageKeys.DataSet).TenantID;
    //     let license = JSON.parse(localStorage.getItem('agrisLicense'));
    //     this.PostServerCommand(`/culturahub/RESTCommandWebService/ExecuteServerCommand/AgrisLicenseProcessor/ReleaseLicense?TenantID=${tenantId}&UserID=${license.username}&Password=${encodeURIComponent(license.password)}&ExtendedOption=nko&ExtendedOptionValue=NAM12&AgrisSessionId=${license.agrisLicense}`, {}
    //         , (data) => {
    //             if (data.Message == "True") { callback(true); }
    //             else {
    //                 Sentry.captureMessage("Handled Error: " + JSON.stringify(data));
    //                 callback(false);
    //             }
    //         }, (error) => {
    //             this.alertAndLogError(error);
    //             failedcallback(error);
    //         })
    // }

    alertAndLogError(error) {
        Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
        this.alertService.error('License count exceeded. To continue using the app, contact your administrator to ensure there are enough licenses available before retrying.');
        console.log(error);
    }
    async GetAgentSessionId(remoteServer: string, agentUsername: string, agentEncPassword: string, customerKey: string, uiDefId: string, SessionID: string = null): Promise<any> {
        try {
            let settings = JSON.parse(localStorage.getItem('settings'));
            if (settings && settings.agentEmail && settings.agentEncryptedPassword) {
                let data: any = await this.GetActivation(remoteServer, settings.agentEmail, settings.agentEncryptedPassword, settings.appName);

                let payload: any;
                if (data && data.MoreInfo) {
                    settings.AgentId = data.MoreInfo.AgentId;
                    settings.AgentUserName = data.MoreInfo.UserName;
                    settings.Password = data.MoreInfo.Password;
                    localStorage.setItem('settings', JSON.stringify(settings));

                    payload = {
                        Password: data.MoreInfo.Password,
                        Username: data.MoreInfo.UserName,
                        DeviceName: this.deviceName,
                        SessionID: SessionID,
                        CustomerID: customerKey,
                        UIDefID: uiDefId
                    };

                    let url = `https://${remoteServer}/culturahub/RESTSecurityWebService/Authenticate`;
                    let response: any = await this.http.post(url, payload, { headers: this.headers }).toPromise();
                    if (response) {
                        // console.log("old agent SessionId =>", settings.agentSessionId);
                        settings.agentSessionId = response.SessionID;
                        // console.log("new agent SessionId =>", settings.agentSessionId);

                        localStorage.setItem('settings', JSON.stringify(settings));
                        return settings.agentSessionId;
                    }
                }
            }
        } catch (ex: any) {
            let message = `Error-in-GetAgentSessionId => ${ex.message}`;
            ex.Message = message;
            Sentry.captureEvent(ex);
        }
        return null;
    }

    async GetActivation(remoteServer: string, clientEmail: string, clientPassword: string, appName: string): Promise<any> {
        clientEmail = clientEmail;
        clientPassword = encodeURIComponent(clientPassword);
        let adminSessionId: any = await this.GetAdminSessionId(remoteServer);
        if (adminSessionId) {
            try {
                return this.activateApp(clientEmail, clientPassword);
            } catch (ex: any) {
                let message = `Error-in-GetActivation => ${ex.message}`;
                ex.Message = message;
                Sentry.captureEvent(ex);
            }
        }
        return null;
    }
    async activateApp(clientEmail, clientPassword): Promise<any> {
    
        return new Promise(async (resolve, reject) => {
            var settings = this.storage.get(StorageKeys.Settings);
            let SessionID = settings ? settings.agentSessionId : null;
            let customerKey = settings ? settings.customerKey : null;
            let body = {
                "AgentEmail": clientEmail,
                "AgentEncryptedPassword": clientPassword,
            }
            let remoteUrl = utils.GetSalesReviewRemoteServer();

            await this.Post((data: any) => {
                if (data) {
                    resolve(JSON.parse(data));
                }
                else
                    reject('No Data Found!')
            }
                , `${remoteUrl}/AgrisLicense/ActivateApp`
                , body
                , customerKey
                , SessionID
                , null
                , (error: any) => {
                    reject(error);
                },
                false,
                false,
            );
        });
    }
    async GetAdminSessionId(remoteServer: string): Promise<any> {
        let remoteURL = `https://${remoteServer}/culturahub/RESTSecurityWebService/Authenticate`;
        let body: any = {
            Password: "TLJUFZIZQPB+u9y1mPfmSw==",
            Username: "apiAdmin",
            DeviceName: this.deviceName,
            UIDefID: this.defaultUIDefIDKey,
            CustomerID: this.defaultCustomerKey,
            SessionID: null
        };
        try {
            let response: any = await this.http.post(remoteURL, body, { headers: this.headers }).toPromise();
            if (response && response.SessionID) {
                return response.SessionID;
            }
        } catch (ex: any) {
            let message = `Error-in-GetAdminSessionId => ${ex.message}`;
            ex.Message = message;
            Sentry.captureEvent(ex);
        }

        return null;

    }
    private addUniqueQueryParam(url: string): string {
        const uniqueParam = `cacheBuster=${new Date().getTime()}`;
        return url.includes('?') ? `${url}&${uniqueParam}` : `${url}?${uniqueParam}`;
    }
    async GetAuthToken(remoteUrl, agentSessionId, Audience): Promise<any> {
        return new Promise(async (resolve, reject) => {
            let dataset = localStorage.getItem('dataSet');
            let tenantId;
            if (dataset) {
                tenantId = JSON.parse(dataset).TenantID;
            }
            let agentId = localStorage.getItem('AgentId');
            let username;
            let license = localStorage.getItem('agrisLicense');
            if (license) {
                username = JSON.parse(license).username;
            }

            let GetStagingRemoteServer = utils.GetStagingRemoteServer();
            let BookingClientID = utils.GetBookingClientID();
            let BookingClientSceret = utils.GetBookingClientSceret();
            let GetBookingClientAudience = utils.GetBookingClientAudience();
            let GetActionListClientAudience = utils.GetActionListClientAudience();

            let request: any = {
                tenantId: tenantId,
                agentId: agentId,
                sessionId: agentSessionId,
                userId: username,
                clientId: BookingClientID,
                ClientSecretKey: BookingClientSceret,
                ClientAudience: Audience

            };
            let body = {
                EncryptedData: this.crypto.encryptString(JSON.stringify(request))
            }
            // const parsedUrl = new URL(remoteUrl); // Parse the URL
            // let actionListRemote = parsedUrl.hostname; // Extract the hostname

            let url = GetStagingRemoteServer + `/Auth/GetAuthToken`;
            try {
                await this.Post((res) => {
                    if (!environment.production) {
                        console.log(res);
                    }
                    if (res && res.TransactionObject) {
                        if (Audience == GetActionListClientAudience) {
                            this.storage.set(StorageKeys.AuthActionListApiToken, JSON.stringify(res.TransactionObject[0]));
                        } else if (Audience == GetBookingClientAudience) {
                            this.storage.set(StorageKeys.AuthBookingApiToken, JSON.stringify(res.TransactionObject[0]));
                        } else {
                            this.storage.set(StorageKeys.AuthEsignApiToken, JSON.stringify(res.TransactionObject[0]));
                        }
                        resolve(res.TransactionObject[0].Token);
                    } else {
                        reject(res.ErrorMessage);
                    }
                }, url, body, undefined, agentSessionId, undefined, (error) => {
                    reject(error.ErrorMessage);
                }, undefined, undefined, undefined, true);
            } catch (e: any) {
                let message = `Error-in-GetAuthToken => ${e.message}`;
                if (!environment.production) {
                    console.log(message);
                }
            }
        });
    }
    private async GetAuthTokenFormLocal(url: string, SessionID: any): Promise<string> {

        let auth0 = null;
        let authexpiry = null;
        let token = null;
        let Audience = null;
        let SalesReviewRemoteServer = utils.GetSalesReviewRemoteServer();
        let GetStagingRemoteServer = utils.GetStagingRemoteServer();
        let GetSEsignRemoteServer = utils.GetSEsignRemoteServer();
        let GetActionListClientAudience = utils.GetActionListClientAudience();
        let GetEsignClientAudience = utils.GetEsignClientAudience();
        let GetBookingClientAudience = utils.GetBookingClientAudience();


        if (url.includes(GetStagingRemoteServer)) {
            token = this.storage.get(StorageKeys.AuthActionListApiToken);
            Audience = GetActionListClientAudience;
        }
        else if (url.includes(GetSEsignRemoteServer)) {
            token = this.storage.get(StorageKeys.AuthEsignApiToken);
            Audience = GetEsignClientAudience;
        }
        else if (url.includes(SalesReviewRemoteServer)) {
            token = this.storage.get(StorageKeys.AuthBookingApiToken);
            Audience = GetBookingClientAudience;
        }

        if (token) {
            const parsedToken = JSON.parse(token);
            auth0 = parsedToken.Token;
            authexpiry = parsedToken.Expire; // Assuming `Expire` is in Unix timestamp format (milliseconds)
        }

        const date = new Date(authexpiry);
        const millisecondsAuthexpiry = date.getTime();
        const currentUtcTime = new Date().getTime(); // Current UTC time in milliseconds
        const authexpiryUtc = millisecondsAuthexpiry || 0;

        if (!auth0 || authexpiryUtc < currentUtcTime) {
            auth0 = this.GetAuthToken(url, SessionID, Audience);
        }
        return auth0;
    }


    cancelRequests() {
        if (!environment.production) {
            console.log('Cancel signal emitted from RequestHelper.');
        }
        this.cancelRequests$.next(true);
    }

    destroy() {
        this.cancelRequests$.complete();
    }


    public ngOnDestroy(): void {
        // This aborts all HTTP requests.
        this.cancelRequests$.next(true);
        // This completes the subject properlly.
        this.cancelRequests$.complete();
    }

}